import React, { useContext, useState } from 'react';
import {
  Dropdown,
  //Input,
  MenuProps,
} from 'antd';
import {
  //SearchOutlined,
  UserOutlined,
  MessageOutlined,
  LogoutOutlined,
  LockOutlined,
} from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import MarketShoppingCartIcon from '../shared/cart/MarketShoppingCartIcon';
import NotificationBadge from '../shared/notifications/NotificationBadge';
import { ChatContext } from '@/context/Chat';
import { useEntityNavigation } from '@/hooks/utils/useEntityNavigationLink';
import { useLoggedUser } from '@/hooks/user/useLoggedUser';
import { useSessionAuth } from '@/context/Auth';
import ChangePasswordModal from '../shared/ChangePasswordModal';

const Header: React.FC = () => {
  const { logout } = useSessionAuth();
  const { toggleChatBox } = useContext(ChatContext);
  const [isChangePasswordModalOpen, setIsChangePasswordModalOpen] =
    useState(false);

  const navigate = useNavigate();
  const { marketId } = useParams();
  const { userType, isSuperAdmin } = useLoggedUser();
  const { navigateTo } = useEntityNavigation();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const items: MenuProps['items'] = [
    {
      key: '1',
      label: 'My Profile',
      disabled: userType === 'ADMIN',
      onClick: () => {
        navigateTo(`/profile`);
      },
    },
    {
      key: '2',
      label: 'Change Password',
      icon: <LockOutlined />,
      onClick: () => {
        setIsChangePasswordModalOpen(true);
      },
    },
    {
      type: 'divider',
    },
    {
      key: '4',
      label: 'Logout',
      icon: <LogoutOutlined />,
      onClick: handleLogout,
    },
  ];

  return (
    <>
      <header className="flex items-center justify-between px-6 py-4 bg-white shadow-lg z-30 fixed top-0 right-0 start-[250px]">
        <div className="flex items-center"></div>
        <div className="flex items-center space-x-4">
          {userType === 'MARKET' && (
            <MarketShoppingCartIcon marketId={marketId} />
          )}

          {userType !== 'ADMIN' && !isSuperAdmin && (
            <>
              <NotificationBadge onClick={() => navigateTo(`/notifications`)} />
              <MessageOutlined
                className="text-xl cursor-pointer"
                onClick={toggleChatBox}
              />
            </>
          )}

          <Dropdown menu={{ items }}>
            <UserOutlined className="text-xl cursor-pointer" />
          </Dropdown>
        </div>
      </header>

      <ChangePasswordModal
        isOpen={isChangePasswordModalOpen}
        onClose={() => setIsChangePasswordModalOpen(false)}
      />
    </>
  );
};

export default Header;
